import { useAuth0 } from '@auth0/auth0-react';

import { environment as env } from '@/environments';

export function useUserRoles() {
  const { user } = useAuth0();
  return user && (user[`${env.auth0Audience}roles`] as string[]);
}
